// extracted by mini-css-extract-plugin
export default {"container":"Attestations-module__container--oTCwt","attestation":"Attestations-module__attestation--ZT3u2","attestationCheckbox":"Attestations-module__attestationCheckbox--BoU79"};